{
  "type": "object",
  "properties": {
    "PhotoDescription": { "type": "string", "minLength": 1 },
    "IntendedFor": {
      "anyOf": [
        { "type": "string", "minLength": 1 },
        {
          "type": "array",
          "items": { "type": "string", "minLength": 1 },
          "minItems": 1
        }
      ]
    }
  }
}
